import { useEffect,useRef, useState } from 'react'
import AOS from 'aos'
import Button from '@ui/Button'
import { SITE,ROUTES } from '@/constants'
import proposeBg from '/assets/images/propose-bg.jpg'
import Breadcrumb from '@common/Breadcrumb'
import { useRecaptcha } from '@helpers/useRecaptcha'
import { MAIL_API_URL, buildPartnerEmailBody, readEnquiryStatus } from '@/helpers/sendMail'
import MetaInfo from '@common/MetaInfo'
import { metaTitleFor } from '../assets/js/navBreadcrumb'
const { label, pageDesc, metaDesc } = metaTitleFor(ROUTES.BE_A_PARTNER)

// ── Content — verbatim from the reference page, not modified ──
const PARTNER_PANELS = [
  {
    number: '01',
    title: 'We Make Sales',
    steps: [
      'You have a customer who needs our services.',
      'You put us in contact by sending an introduction letter.',
      'Our Sales Team takes care of negotiation with the client.',
      'Upon signing a contract, we provide you a pre-decided percentage out of each payment the client has made.',
    ],
    note: 'All further communication with the client will be held directly by our Project Manager.',
  },
  {
    number: '02',
    title: 'You Make Sales',
    steps: [
      'You have a customer who needs our services.',
      'You put us in contact by sending an introduction letter.',
      'You take care of communication process, including company presentation (samples, portfolio, team members CVs) and further negotiations on project time & price.',
      "If you've managed to sell the project at our price (plus your share) we'll sign a contract and get to work right away.",
    ],
    note: 'All further communication with the client will be held directly by our Project Manager.',
  },
  {
    number: '03',
    title: 'Subcontracting to CruxBytes',
    steps: [
      'You have a customer who is interested in our services.',
      'You outsource software development scope of work to our team.',
    ],
    note: "Payment Conditions — If you put us in contact with the client as your partner, we'll cover all payments directly. Otherwise, you'll be responsible for delivering payments on time. Meaning, if the client holds the payment, this won't be a good reason for you to hold it for us.",
  },
]

const INTEREST_OPTIONS = [
  'Collaboration Feasibility',
  'Subcontracting For A Government Tender',
  'Any Other',
]

const INIT = { name: '', company: '', email: '', mobile: '', interest: '' }

function validate(form) {
  const errors = {}
  if (!form.name.trim())  errors.name  = 'Name is required'
  if (!form.email.trim()) errors.email = 'Email is required'
  else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) errors.email = 'Invalid email address'
  return errors
}
// function useRecaptcha(containerRef, onVerify) {
//   useEffect(() => {
//     const siteKey = import.meta.env.VITE_RECAPTCHA_SITE_KEY
//     function render() {
//       if (window.grecaptcha && containerRef.current && !containerRef.current.dataset.rendered) {
//         window.grecaptcha.render(containerRef.current, {
//           sitekey: siteKey,
//           callback: onVerify,
//           'expired-callback': () => onVerify(null),
//         })
//         containerRef.current.dataset.rendered = 'true'
//       }
//     }
//     if (window.grecaptcha?.render) { render(); return }
//     const scriptId = 'grecaptcha-script'
//     if (!document.getElementById(scriptId)) {
//       window.__onRecaptchaLoad = render
//       const script = document.createElement('script')
//       script.id   = scriptId
//       script.src  = 'https://www.google.com/recaptcha/api.js?onload=__onRecaptchaLoad&render=explicit'
//       script.async = true; script.defer = true
//       document.body.appendChild(script)
//     } else { window.__onRecaptchaLoad = render }
//   }, [containerRef, onVerify])
// }
const MAIL_SUBJECT = 'Website Enquiry | Partnerships'
export default function PartnershipsPage() {
  
  //useEffect(() => { AOS.refresh(); window.scrollTo(0, 0) }, [])
  const [captchaToken, setCaptchaToken]   = useState('')
  const [pendingSubmit, setPendingSubmit] = useState(false)
  const formRef = useRef(null)
  const { execute: executeRecaptcha } = useRecaptcha()
  const [form, setForm] = useState(INIT)
  const [errors, setErrors] = useState({})
  const [status, setStatus] = useState('idle')

  const handleChange = (e) => {
    const { name, value } = e.target
    setForm((f) => ({ ...f, [name]: value }))
    if (errors[name]) setErrors((er) => ({ ...er, [name]: '' }))
  }

// const handleSubmit = (e) => {
//   const errs = validate(form)
//   if (Object.keys(errs).length) {
//     e.preventDefault()
//     setErrors(errs)
//     return
//   }

//   if (!recaptchaToken) {
//     e.preventDefault()
//     setErrors(er => ({ ...er, recaptcha: 'Please verify you are not a robot' }))
//     return
//   }
//   setStatus('loading')
// }

// v3 runs invisibly with no widget/challenge — execute() resolves directly
// with a token. Submission waits for it before the native POST fires
// (fetch can't be used here: no CORS on the mail-sending API).
const handleSubmit = async (e) => {
  e.preventDefault()

  const errs = validate(form)
  if (Object.keys(errs).length) { setErrors(errs); return }
  setStatus('loading')

  try {
    const token = await executeRecaptcha('partnership_enquiry')
    setCaptchaToken(token)
    setPendingSubmit(true)
  } catch {
    setStatus('idle')
    setErrors(er => ({ ...er, recaptcha: 'Verification failed. Please try again.' }))
  }
}

useEffect(() => {
  if (pendingSubmit && captchaToken) {
    setPendingSubmit(false)
    formRef.current?.submit()
  }
}, [pendingSubmit, captchaToken])
// inside component, after useState declarations:
useEffect(() => {
  const result = readEnquiryStatus()
  if (result) setStatus(result)
}, [])
  return (
    <> 
     {/* <MetaInfo
        title="Partnership | CruxBytes"
        description="Join the CruxBytes partnership program. Refer clients, sell our services or subcontract software development to our team, and grow together."
        keywords="partnership program, become a partner, software development partner, referral program, IT subcontracting, reseller partner, CruxBytes"
      /> */}

             <MetaInfo
                 title={label} 
                  description={metaDesc}                   
                  keywords=""
                  />
    <main id="main-content" className="page-wrapper">
      {/* Hero — untouched, same pattern as your other inner pages */}
      <div className="page-hero">
        <div className="bg-grid bg-grid--fill" aria-hidden="true" />
        <div className="container">
         {/* <div className="section-label">- Program for Companies -</div> */}
         <Breadcrumb />
          <h1 data-aos="fade-up" data-aos-delay={100}>
            {/* We'd love to help you with your software needs */}
            {label}
            </h1>
          <p className="page-subtitle" data-aos="fade-up" data-aos-delay={200}>
            {/* We always welcome new partners. */}
            {pageDesc}
            </p>
          
          <div className="inner-page-actions">
            <Button href="#partner-form" variant="primary" icon="fa-arrow-right" iconPos="right" data-aos="fade-up" data-aos-delay={300}>
              Let's work together
            </Button>
          </div>
        </div>
      </div>

      {/* Partnership Program — 3 numbered panels */}
      <section className="section-py" aria-labelledby="partnership-heading">
        <div className="container">
          <div className="section-header">
            <div className="section-label" data-aos="fade-up" >- Affiliate -</div>
            <h2 id="partnership-heading" data-aos="fade-up" data-aos-delay={100}>Partnership Program</h2>
          </div>

          <div className="partner-panels">
            {PARTNER_PANELS.map((panel) => (
              <div className="process-card partner-panel" key={panel.number} data-aos="fade-up">
                <span className="process-watermark" aria-hidden="true">{panel.number}</span>
                <span className="process-badge">{panel.number}</span>
                <h3 >{panel.title}</h3>
                <ol className="partner-steps">
                  {panel.steps.map((step, i) => (
                    <li key={i} className="partner-step">{step}</li>
                  ))}
                </ol>
                <p className="partner-note">{panel.note}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Mid-page CTA strip */}
      {/* Mid-page CTA strip — parallax photo background */}
      <section className="partner-cta-strip" aria-labelledby="partner-cta-heading">
        <div
          className="partner-cta-bg"
          style={{ backgroundImage: `url(${proposeBg})` }}
          aria-hidden="true"
        />
        <div className="partner-cta-overlay" aria-hidden="true" />
        <div className="container partner-cta-inner text-center">
          <h2 id="partner-cta-heading" className="partner-cta-heading" data-aos="fade-up" data-aos-delay={100}>
            Coming together is a beginning, staying together is progress and working together is a SUCCESS.
          </h2>
        </div>
      </section>

      {/* Contact form */}
      <section id="partner-form" className="partner-cta-strip" aria-labelledby="partner-form-heading">
        <div className="container" style={{ textAlign: 'center', marginBottom: '2.5rem' }}>
          <h2 id="partner-form-heading" >
            Contact us. We'll find a mutually beneficial way of cooperation!
          </h2>
        </div>

        <div className="container">
          <div className="contact-form-wrap" style={{ maxWidth: 640, margin: '0 auto' }} data-aos="fade-up">
            {status === 'success' ? (
              <div className="contact-success" role="alert">
                <i className="fa-solid fa-circle-check" />
                <h3>Thank you!</h3>
                <p>We'll be in touch to discuss your partnership terms.</p>
                <Button size="sm" variant="secondary" onClick={() => setStatus('idle')}>Send Another</Button>
              </div>
            ) : (
            <form
                    ref={formRef}
                    onSubmit={handleSubmit}
                    action={MAIL_API_URL}
                    method="POST"
                    className="contact-form"
                    noValidate
                    aria-label="Partnership enquiry form"
                  >
                    {/* Hidden fields */}
                    <input type="hidden" name="EmailTo"   value={form.email} />
                    <input type="hidden" name="EmailBcc"  value={SITE.mail_cc} />
                    <input type="hidden" name="Subject"   value={MAIL_SUBJECT} />
                    <input type="hidden" name="EmailBody" value={buildPartnerEmailBody(form)} />
                    <input type="hidden" name="name"      value={form.name} />
                    <input type="hidden" name="email"     value={form.email} />
                    <input type="hidden" name="contact"   value={form.mobile} />
                    <input type="hidden" name="EmailAlias"   value={SITE.emailAlias} />
                    <input type="hidden" name="eMailSenderIDFrom"   value={SITE.eMailSenderIDFrom} />
                    {/* <input type="hidden" name="ReturnUrl" value={ROUTES.BE_A_PARTNER} /> */}
                      
                      <input type="hidden" name="source" value="partnerships" />
                <div className="form-row">
                  <div className="form-field">
                    <label htmlFor="name" className="form-label">
                      Your Name <span className="form-req" aria-hidden="true">*</span>
                    </label>
                    <input id="name" name="name" type="text" placeholder="Your name"
                      value={form.name} onChange={handleChange}
                      className={`form-input${errors.name ? ' form-input-error' : ''}`}
                      aria-required="true" aria-invalid={!!errors.name}
                      aria-describedby={errors.name ? 'err-name' : undefined} autoComplete="name" />
                    {errors.name && <span id="err-name" role="alert" className="form-err-msg">{errors.name}</span>}
                  </div>
                  <div className="form-field">
                    <label htmlFor="company" className="form-label">Company</label>
                    <input id="company" name="company" type="text" placeholder="Your company"
                      value={form.company} onChange={handleChange} className="form-input" autoComplete="organization" />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-field">
                    <label htmlFor="email" className="form-label">
                      Email <span className="form-req" aria-hidden="true">*</span>
                    </label>
                    <input id="email" name="email" type="email" placeholder="you@company.com"
                      value={form.email} onChange={handleChange}
                      className={`form-input${errors.email ? ' form-input-error' : ''}`}
                      aria-required="true" aria-invalid={!!errors.email}
                      aria-describedby={errors.email ? 'err-email' : undefined} autoComplete="email" />
                    {errors.email && <span id="err-email" role="alert" className="form-err-msg">{errors.email}</span>}
                  </div>
                  <div className="form-field">
                    <label htmlFor="mobile" className="form-label">Mobile</label>
                    <input id="mobile" name="mobile" type="tel" placeholder="+91 XXXXX XXXXX"
                      value={form.mobile} onChange={handleChange} className="form-input" autoComplete="tel" />
                  </div>
                </div>

                <div className="form-field">
                  <label htmlFor="interest" className="form-label">Interested In</label>
                  <select id="interest" name="interest" value={form.interest} onChange={handleChange} className="form-input">
                    <option value="">Select an option…</option>
                    {INTEREST_OPTIONS.map((opt) => <option key={opt} value={opt}>{opt}</option>)}
                  </select>
                </div>
                        {/* reCAPTCHA v3 — no visible widget; token travels via hidden field */}
            <input type="hidden" name="g-recaptcha-response" value={captchaToken} />
            {errors.recaptcha && (
              <div className="form-field">
                <span role="alert" className="form-err-msg">{errors.recaptcha}</span>
              </div>
            )}
                  {status === 'error' && (
  <p role="alert" aria-live="assertive" className="form-status form-status-error">
    Sorry, we couldn't send your enquiry. Please try again or contact us directly.
  </p>
)}
                <Button type="submit" loading={status === 'loading'} icon="fa-handshake" iconPos="right">
                  Become a Partner
                </Button>
              </form>
            )}
          </div>
        </div>
      </section>
    </main>
    </>
  )
}